import { useMetaTags } from "../components/MetaTags";

export function TermsOfService() {
  useMetaTags({
    title: "Terms of Service | OmniCanvas",
    description: "OmniCanvas terms of service — account responsibilities, acceptable use, and service terms.",
    url: "https://omnicanvasnotes.com/terms",
    robots: "noindex, follow",
  });

  return (
    <div className="pt-28 pb-20">
      <div className="max-w-3xl mx-auto px-6">
        <p className="text-sm text-slate-400 mb-2">Last updated: March 7, 2026</p>
        <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 mb-8">
          Terms of Service
        </h1>

        <div className="prose prose-slate max-w-none space-y-8 text-slate-600 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Acceptance of Terms</h2>
            <p>
              By accessing or using OmniCanvas, you agree to be bound by these terms. If you
              do not agree, please do not use the service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Account Responsibilities</h2>
            <p>
              You are responsible for maintaining the security of your account credentials. You
              must provide accurate information when creating an account and keep it up to date.
              You are responsible for all activity that occurs under your account.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Acceptable Use</h2>
            <p>
              You agree not to use OmniCanvas for any unlawful purpose or in any way that could
              damage, disable, or impair the service. You must not attempt to gain unauthorized
              access to any part of the service or its related systems.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Intellectual Property</h2>
            <p>
              You retain full ownership of all content you create in OmniCanvas. We do not
              claim any rights to your notes, drawings, or other data. The OmniCanvas software,
              branding, and website content are owned by OmniCanvas and protected by applicable
              intellectual property laws.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Service Availability</h2>
            <p>
              OmniCanvas is provided on an "as-is" and "as-available" basis. We make no
              guarantees regarding uptime, reliability, or availability of the service. We may
              modify, suspend, or discontinue any part of the service at any time.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, OmniCanvas shall not be liable for any
              indirect, incidental, special, consequential, or punitive damages, including loss
              of data, profits, or goodwill, arising from your use of the service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Termination</h2>
            <p>
              We reserve the right to suspend or terminate your account at any time for
              violation of these terms. You may delete your account at any time. Upon
              termination, your right to use the service ceases immediately.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Changes to Terms</h2>
            <p>
              We may update these terms from time to time. We will notify users of material
              changes via email or an in-app notice. Continued use of the service after changes
              constitutes acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Governing Law</h2>
            <p>
              These terms are governed by and construed in accordance with the laws of the
              United States. Any disputes arising from these terms shall be resolved in the
              courts of competent jurisdiction.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Contact</h2>
            <p>
              Questions about these terms? Contact us at{" "}
              <a
                href="mailto:hello@omnicanvasnotes.com"
                className="text-indigo-600 hover:text-indigo-700 underline"
              >
                hello@omnicanvasnotes.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
